var map = {
	"./1.1.jpg": 2362,
	"./1.2.jpg": 3378,
	"./1.3.jpg": 7795,
	"./1.4.jpg": 4818,
	"./10.1.jpg": 8910,
	"./2.1.jpg": 7078,
	"./3.1.jpg": 6314,
	"./3.2.jpg": 8119,
	"./4.1.jpg": 4693,
	"./4.2.jpg": 8532,
	"./5.1.jpg": 9644,
	"./5.2.jpg": 9319,
	"./6.1.jpg": 6520,
	"./6.2.jpg": 3945,
	"./7.1.jpg": 2964,
	"./7.2.jpg": 108,
	"./7.3.jpg": 1834,
	"./8.1.jpg": 9574,
	"./8.2.jpg": 8549,
	"./9.1.jpg": 6575,
	"./9.2.jpg": 114,
	"./error.svg": 8067,
	"./interreg_logo.jpg": 7256,
	"./project_logo.jpg": 9087,
	"./project_logo.png": 5999,
	"./project_logo.svg": 8577,
	"./rotunda.jpg": 834,
	"./thessaloniki.jpg": 7719,
	"./thessaloniki2.jpg": 969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;